export const SET_ANALYTICS_DATA = 'SET_ANALYTICS_DATA'
export const SET_MAP_BOUNDS = 'SET_MAP_BOUNDS'

export const setAnalyticsData = payload => dispatch =>
  dispatch({
    type: SET_ANALYTICS_DATA,
    payload: payload
  })
export const setMapBounds = payload => dispatch =>
  dispatch({
    type: SET_MAP_BOUNDS,
    payload: payload
  })
